(function() {

  em.shareLinks = {};

  em.shareLinks.init = function() {

    const shareLinkEls = document.querySelectorAll('.js-share-link');

    shareLinkEls.forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();

        const url = el.getAttribute('href');

        if (!url) {
          return false;
        }

        em.shareLinks.openShareWindow(url);
      });
    });
  };

  em.shareLinks.openShareWindow = function(url) {
    const left = (screen.width - 570) / 2;
    const top = (screen.height - 570) / 2;
    const params =
      'menubar=no,toolbar=no,status=no,width=570,height=570,top=' +
      top +
      ',left=' +
      left;

    window.open(url, 'NewWindow', params);
  };

})();
